import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";

/**
 * Tracks pageviews in PostHog on route changes.
 * Manual capture is needed because PostHog's automatic pageview only fires
 * on full page loads, not on React Router client-side navigations.
 */
export const usePostHogPageview = (): void => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview", {
        $current_url: window.location.href,
      });
    }
  }, [location.pathname, posthog]);
};
